import { useCallback, useMemo } from 'preact/hooks';
import type { TpaasPlugin } from '@schibsted-svp/web-player';

import { usePlayer } from './PlayerProvider';

type TrackEngagementUIElementInput = Parameters<
  TpaasPlugin['trackEngagementUIElement']
>[0];

type TrackEngagementTeaserInput = Parameters<
  TpaasPlugin['trackEngagementTeaser']
>[0];

type TrackImpressionPlayerInput = Parameters<
  TpaasPlugin['trackImpressionPlayer']
>[0];

type TrackImpressionUIElementInput = Parameters<
  TpaasPlugin['trackImpressionUIElement']
>[0];

export function useTpaasTracker() {
  const player = usePlayer();
  const tpaasTracker = useMemo(() => player.getPlugin('Tpaas'), [player]);

  const trackEngagementUIElement = useCallback(
    (data: TrackEngagementUIElementInput) =>
      tpaasTracker?.trackEngagementUIElement(data),
    [tpaasTracker]
  );

  const trackEngagementTeaser = useCallback(
    (data: TrackEngagementTeaserInput) =>
      tpaasTracker?.trackEngagementTeaser(data),
    [tpaasTracker]
  );

  const trackImpressionPlayer = useCallback(
    (data: TrackImpressionPlayerInput) =>
      tpaasTracker?.trackImpressionPlayer(data),
    [tpaasTracker]
  );

  const trackImpressionUIElement = useCallback(
    (data: TrackImpressionUIElementInput) =>
      tpaasTracker?.trackImpressionUIElement(data),
    [tpaasTracker]
  );

  return {
    trackEngagementUIElement,
    trackEngagementTeaser,
    trackImpressionPlayer,
    trackImpressionUIElement,
  };
}
